import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getSelection,
  $isRangeSelection,
  $isRootNode,
  COMMAND_PRIORITY_CRITICAL,
  SELECTION_CHANGE_COMMAND,
} from "lexical";
import { useEffect, useState } from "react";

export function NoRootSelectionPlugin(): null {
  const [editor] = useLexicalComposerContext();
  const [changingSelection, setChangingSelection] = useState(false);

  useEffect(
    () =>
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        () => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return false;

          const focus = selection.focus.getNode();
          if (!$isRootNode(focus)) return false;

          if (changingSelection) {
            // Avoid infinite loop where selection.modify(..) triggers another selection change
            setChangingSelection(false);
            return false;
          }

          editor.update(() => {
            selection.modify?.("extend", false, "lineboundary");
            setChangingSelection(true);
          });

          return false;
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
    [editor, changingSelection, setChangingSelection],
  );

  return null;
}
